import { getCountry, getWithDotComByCountry, getManualByCountry } from '../utils';

const country = getCountry();
const withCom = getWithDotComByCountry(country);
const withWww = window.location.href.indexOf('www') > -1 ? 'www.' : '';
const docHost = `https://help.neogig${withCom}${country}`;
const linkManual = getManualByCountry(country, docHost);

export const env = {
    NODE_ENV: 'production',
    NEOGIG_CLIENT_ID: 'neogig',
    NEODASH_CLIENT_ID: 'neodash',
    MAPBOX_KEY: `pk.eyJ1IjoibmVvY29tc2VydmljZSIsImEiOiJjbWRpeWIxcmUwZ3N0MmxxMzMwenRtZHF5In0.W4jEtyrV6fR-Ca_AhozucA`,
    GOOGLE_MAPS_API_KEY: 'AIzaSyCr91LtDQSy90KJxHab_LzIi32Wc13sGF0',
    CARTO_KEY: 'cb1_28bg_1_0356ced9998003b244e01e82',
    URL: {
        NEOGIG_HOST: `https://${withWww}neogig${withCom}${country}`,
        NEODASH_HOST: `https://neodash.neogig${withCom}${country}`,
        API_HOST: `https://neogig-api.neogig${withCom}${country}/api/v1`,
        MANUAL_URL: linkManual,
        IDENTITY_SERVER_URL: `https://identity-server.neogig${withCom}${country}`,
        CTRL_PANEL_API: `https://cp-api.neogig${withCom}${country}`,
    }
};



// WEBPACK FOOTER //
// ./src/config/prod.env.js